"use client"

import { useEffect, useState } from "react"
import { Link } from "react-router-dom"

const Header = () => {
  const [isDark, setIsDark] = useState(false)

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme")
    if (savedTheme === "dark") {
      setIsDark(true)
      document.documentElement.setAttribute("data-theme", "dark")
    }
  }, [])

  const handleThemeToggle = () => {
    const html = document.documentElement
    if (isDark) {
      html.removeAttribute("data-theme")
      localStorage.setItem("theme", "light")
      setIsDark(false)
    } else {
      html.setAttribute("data-theme", "dark")
      localStorage.setItem("theme", "dark")
      setIsDark(true)
    }
  }

  return (
    <nav className="navbar navbar-expand-lg navbar-light headback shadow-sm fixed-top">
      <div className="container">
        {/* index.html had href="index.html" → use route "/" */}
        <Link className="navbar-brand fw-bold d-flex align-items-center gap-2" to="/">
          <img src="/images/voyagian-logo.png" alt="Logo" style={{ height: "45px", width: "auto" }} />
          <span style={{ letterSpacing: "1px", textTransform: "uppercase", color: "#061A40" }}>Voyagian</span>
        </Link>

        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse justify-content-center" id="navbarNav">
          <ul className="navbar-nav mx-auto">
            {/* Home – on HTML it was "#" (top of page). Using "/" keeps SPA behavior similar */}
            <li className="nav-item">
              <Link className="nav-link" to="/">
                Home
              </Link>
            </li>

            {/* Same section anchors as HTML */}
            <li className="nav-item">
              <a className="nav-link" href="#features">
                Features
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#how">
                How It Works
              </a>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contacts">
                Contact
              </Link>
            </li>
          </ul>

          <div className="d-flex flex-wrap align-items-center">
            <div className="dropdown">
              <button
                className="btn btn-primary-navy ms-2 dropdown-toggle d-flex align-items-center gap-2"
                type="button"
                id="loginDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Login
              </button>
              <ul className="dropdown-menu dropdown-menu-end shadow border-0 mt-2" aria-labelledby="loginDropdown" style={{ minWidth: "180px" }}>
                <li>
                  <a className="dropdown-item py-2 d-flex align-items-center gap-2" href="https://company.voyagian.com/company-login">
                    <i className="bi bi-building"></i>
                    <span>Company Login</span>
                  </a>
                </li>
                <li>
                  <Link className="dropdown-item py-2 d-flex align-items-center gap-2" to="/saleteam-login">
                    <i className="bi bi-people"></i>
                    <span>Saleteam Login</span>
                  </Link>
                </li>
              </ul>
            </div>

            <button
              id="themeToggle"
              className="theme-toggle ms-2"
              title="Toggle Dark/Light"
              style={{ border: "none" }}
              onClick={handleThemeToggle}
            >
              <i className={`bi ${isDark ? "bi-sun-fill" : "bi-moon-stars-fill"}`}></i>
            </button>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Header
